/**
 * @author Rejo Varghese
 * @description Demand Days related action
 */

import { GET_DEMAND_DAYS, INSERT_DEMAND_DAYS, CLEAR_DEMAND_DAYS } from './action-types';
import { GET_DEMAND_DAYS_URL, INSERT_DEMAND_DAYS_URL } from "../utils/api-url";
import { postCall } from "../utils/network.util";


export const getDemandDaysAction = (originList, destinationList, startDate, endDate) => {
    return {
        type: GET_DEMAND_DAYS,
        payload: {
            url: GET_DEMAND_DAYS_URL,
            api: postCall,
            apiPayload:{
                originList,
                destinationList,
                startDate,
                endDate
            },
        }
    }
}

export const clearDemandDays = () => {
    return {
        type: CLEAR_DEMAND_DAYS,
        payload: {}
    }
}

// export const clearSelectedTrip = ()=>{
//     return{
//         type:CLEAR_SELECTED_TRIP,
//         payload:{}
//     }
// }

export const insertDemandDaysAction = ({originList, destinationList, selectedDate, description}) => {
    return {
        type: INSERT_DEMAND_DAYS,
        payload: {
            url: INSERT_DEMAND_DAYS_URL,
            api: postCall,
            apiPayload:{
                originList, destinationList, selectedDate, description
            },
        }
    }
}
